export const toImgURL = (res) => {
  const regex = /<img.*?src=['"](.*?)['"]/;
  return regex.exec(res)[1];
};
